import React, { useEffect, useState, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { useWallet } from 'use-wallet'
import styled from 'styled-components'

import Page from 'components/Page'
import PageHeader from 'components/PageHeader'
import { PoolListContext } from 'contexts/PoolListProvider'
import PoolsTable from 'components/PoolsTable'

import dice from 'assets/img/dice.png'

const MyPool = (props) => {
  const [data, setData] = useState([])
  const { poolList } = useContext(PoolListContext)
  const { account } = useWallet()
  useEffect(() => {
    if (account && poolList.length > 0) {
      setData(poolList.filter((pool) => pool.owner == account))
    }
    if( poolList.length === 0) {
      handleGoHome()
    }
  }, [account, poolList])

  const history = useHistory()
  const handleGoHome = () => {
    history.push('/')
  }

  return (
    <Page>
      <div>
        <PageHeader
          icon={<img src={dice} height="120" alt="dice" />}
          onClick={handleGoHome}
          title="Pools I own"
        />
        <PoolsTable data={data} />
      </div>
    </Page>
  )
}

const StyledCards = styled.div`
  width: 912px;
  display: flex;
  @media (max-width: 768px) {
    width: 100%;
  }
`
const StyledRow = styled.div`
  display: flex;
  margin-bottom: ${(props) => props.theme.spacing[4]}px;
  flex-flow: row wrap;
  @media (max-width: 768px) {
    width: 100%;
    flex-flow: column nowrap;
    align-items: center;
  }
`
export default MyPool
